window.animarFlip = {};
Boss.ux = {
	tooltip: function(evts){

		if(!window.lasttooltip){
			window.lasttooltip = '';
		}
		if(!window.tooltips){
			window.tooltips = {};
		}

		var el = Boss.targt(evts);
		if(el.getAttribute('data-title') === null && el.parentElement !== null && el.parentElement.getAttribute('data-title') !== null){
			el = el.parentElement;
		}
		if(el.getAttribute('data-title') !== null){

			if(Boss.getById(el.getAttribute('data-title'))){

				var atual = el.getAttribute('data-title');

				var t = Boss.getById(atual);

				var rect = el.getBoundingClientRect();

				var top = (rect.top - t.clientHeight - 10).toFixed(0);
				var left = (rect.left+(rect.width / 2)-(t.clientWidth / 2)).toFixed(0);

				if(t.getAttribute('data-apply') == null){

					tooltips[atual] = atual;
					lasttooltip = atual;

					t.style.top = top+'px';
					t.style.left = left+'px';

					t.setAttribute('data-apply', 'true');
					t.classList.add('boss-tooltip-active');
				}
			}
		}else{
			lasttooltip = '';
		}

		/* REMOVE */
		for(var x in tooltips){
			if(x != lasttooltip){
				if(Boss.getById(x)){
					var tt = Boss.getById(x);
					tt.removeAttribute('data-apply');
					tt.classList.remove('boss-tooltip-active');
					delete tooltips[x];
				}
			}
		}
	},
	textFlip: {
		mem: {},
		next: function(){

			var l = Object.keys(this.mem).length;

			for(var x = 0; x < l; x++){

				var li = this.mem[x].ol.querySelectorAll('li');
				var lli = li.length;
				var at = this.mem[x].at;

				/* NEXT */
				if(li[(at + 1)]){
					li[at].classList.remove('ux-flipshow');
					li[(at + 1)].classList.add('ux-flipshow');
					this.mem[x]['at'] = at + 1;
				}else{

					this.mem[x]['at'] = 0;
					li[at].classList.remove('ux-flipshow');
					li[0].classList.add('ux-flipshow');

				}
			}
		},
		init: function(){

			/* CLEAR OLDS */
			for(var z in animarFlip){
				clearInterval(animarFlip[z]);
			}

			var ol = document.querySelectorAll('[data-flip]');
			var lol = ol.length;

			for(var x = 0; x < lol; x++){

				var dataflip = ol[x].getAttribute('data-flip');
				this.mem[x] = {'ol': ol[x], 'at': 0};

				var li = ol[x].querySelectorAll('li');
				var lli = li.length;

				for(var y = 0; y < lli; y++){
					if(y == 0){
						li[y].classList.add('ux-fliphide');
						li[y].classList.add('ux-flipshow');
					}else{
						li[y].classList.add('ux-fliphide');
					}
				}
			}

			clearInterval(animarFlip[dataflip]);
			animarFlip[dataflip] = setInterval(function(){
				Boss.ux.textFlip.next();
			}, 4000);
		}
	},
	blurup: function(){

		var imgs = document.querySelectorAll('img');
		var timgs = imgs.length;

		var backgrounds = document.querySelectorAll('[data-src-background]');
		var tbackgrounds = backgrounds.length;

		for(var x = 0; x < timgs; x++){
			var ig = imgs[x];

			/* IMG TAG */
			if(ig.getAttribute('data-src')){
				var sr = ig.getAttribute('data-src');
				var id = 'blur-up'+(Math.random()*1000000).toFixed(0);

				if(ig.getAttribute('id')){
					id = ig.getAttribute('id');
				}else{
					ig.setAttribute('id', id);
				}

				var i = new Image();
				i.setAttribute('data-blurupto', id);
				i.setAttribute('src', sr);
				i.onload = function(){

					if(this.getAttribute('data-blurupto') && this.getAttribute('src')){
						if(Boss.getById(this.getAttribute('data-blurupto'))){
							Boss.getById(this.getAttribute('data-blurupto')).setAttribute('src', this.getAttribute('src'));
							Boss.getById(this.getAttribute('data-blurupto')).classList.remove('blur-up');
						}
					}
				}
			}
		}

		for(var x = 0; x < tbackgrounds; x++){
			var ig = backgrounds[x];

			/* IMG BACKGROUND */
			if(ig.getAttribute('data-src-background')){

				var sr = ig.getAttribute('data-src-background');
				var id = 'blur-up'+(Math.random()*1000000).toFixed(0);

				if(ig.getAttribute('id')){
					id = ig.getAttribute('id');
				}else{
					ig.setAttribute('id', id);
				}

				var i = new Image();
				i.setAttribute('data-blurupto', id);
				i.setAttribute('src', sr);
				i.onload = function(){

					if(this.getAttribute('data-blurupto') && this.getAttribute('src')){
						if(Boss.getById(this.getAttribute('data-blurupto'))){
							Boss.getById(this.getAttribute('data-blurupto')).style.backgroundImage = 'url('+this.getAttribute('src')+')';
						}
					}
				}
			}
		}
	},/*
	isElementVisible: function(el){

		if(el != null){
			var rect 	= el.getBoundingClientRect();
			var vWidth	= window.innerWidth || doc.documentElement.clientWidth;
			var vHeight	= window.innerHeight || doc.documentElement.clientHeight;
			var efp 	= function (x, y){
				return document.elementFromPoint(x, y)
			};

			if(rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight){
			    return false;
			}

			return (el.contains(efp(rect.left,  rect.top)) ||  el.contains(efp(rect.right, rect.top)) ||  el.contains(efp(rect.right, rect.bottom)) ||  el.contains(efp(rect.left,  rect.bottom)));
		}
	},*/
	autoClip: function(id){
		if(Boss.getById(id)){
			Boss.evts.add(Boss.evtTouchUp(), Boss.getById(id), function(evts){
				var el = Boss.targt(evts);
				if(el.classList.contains('boss-auto-clipboard')){
					Boss.ux.clip(el);
					el.classList.add('boss-auto-clipboard-sucess');
					Boss.delay(function(){
						el.classList.remove('boss-auto-clipboard-sucess');
					}, 2000);
				}
			});
		}
	},
	clip: function(el){
		var tx = document.createElement('textarea');
		tx.textContent = el.textContent.replace(/\s+$/, '').replace(/^\s+/, '');
		tx.focus();
		tx.classList.add('hidden');
		tx.style.width = '1px';
		tx.style.height = '1px';
		el.appendChild(tx);
		tx.select();
		document.execCommand('copy');
		Boss.delay(function(){
			Boss.remover(tx);
		}, 10);
	},
	textarea: {
		mem: {},
		heightTextarea: function(id){

			if(Boss.getById(id)){
				
				var min = false;
				var max = false;
				var el = Boss.getById(id);

				if(typeof(Boss.ux.textarea.mem[id].min) !== 'undefined' && Boss.ux.textarea.mem[id].min > 0){
					min = Boss.ux.textarea.mem[id].min;
				}
				if(typeof(Boss.ux.textarea.mem[id].max) !== 'undefined' && Boss.ux.textarea.mem[id].max > 0){
					max = Boss.ux.textarea.mem[id].max;
				}

				el.style.overflow = 'hidden';
				el.style.height = 'auto';

				if(min !== false){
					el.style.minHeight = min+'px';
				}

				if(max !== false && el.scrollHeight <= max){
					el.style.height = el.scrollHeight+'px';
				}else{
					el.style.height = max+'px';
					el.style.overflow = 'auto';
				}
			}
		},
		height: function(id, obj){

			if(Boss.getById(id)){

				if(typeof(obj) !== 'object'){
					obj = {};
				}

				var el = Boss.getById(id);

				Boss.ux.textarea.mem[id] = obj;
				Boss.ux.textarea.heightTextarea(id);

				Boss.evts.add('keyup', el, function(evt){
					Boss.ux.textarea.heightTextarea(id);
				});

				Boss.evts.add('mouseup', el, function(evt){
					Boss.ux.textarea.heightTextarea(id);
				});

				Boss.evts.add('paste', el, function(evt){
					Boss.ux.textarea.heightTextarea(id);
				});

				Boss.evts.add('cut', el, function(evt){
					Boss.ux.textarea.heightTextarea(id);
				});
			}
		}
	}
};
Boss.evts.add('mousemove', document, function(evts){
	Boss.ux.tooltip(evts);
});